import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes, routesLists} from "../../../../../core/models/static/routes/app-routes";
import WarrantyAndReturnSingle from "./single";
import WarrantyAndReturnStatusesView from "./settings/statuses";
import WarrantyAndReturnProcessSettings from "./settings/process";
import PartSupportRequestListView from "./list";
import DriversView from "./drivers";
import useAccessLevels from "../../../../hooks/use-access-levels";


const PartSupportRequestViews = () => {
    const operatorAccessLevels = useAccessLevels();
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for the changes in the url and with each change:
     * if the route is the same as warranty-return base, then replaces the route to requests view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.warrantyAndReturnOld.base, exact: false})) {
            // we need to redirect to the new route
            history.replace({
                pathname: location.pathname.replace(routes.warrantyAndReturnOld.base, routes.warrantyAndReturn.base),
                search: location.search,
                hash: location.hash,
                state: location.state,
            });
            return;
        }
        if (matchPath(location.pathname, {path: routes.warrantyAndReturn.base, exact: true})) {
            if (operatorAccessLevels.packages.warrantyAndReturn.viewList) {
                history.replace(routes.warrantyAndReturn.requests);
            } else if (operatorAccessLevels.packages.warrantyAndReturn.drivers) {
                history.replace(routes.drivers);
            } else if (operatorAccessLevels.packages.warrantyAndReturn.editConfigurations) {
                history.replace(routes.warrantyAndReturn.settings.process);
            } else {
                history.replace(routes.warrantyAndReturn.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [operatorAccessLevels.packages.warrantyAndReturn.drivers, operatorAccessLevels.packages.warrantyAndReturn.editConfigurations, operatorAccessLevels.packages.warrantyAndReturn.viewList, history, location.pathname, location.search, location.hash, location.state])

    return (
        <Switch>
            <Route path={routes.warrantyAndReturn.base} exact/>
            <Route path={routesLists.warrantyAndReturnOld} exact/>
            {
                operatorAccessLevels.packages.warrantyAndReturn.drivers &&
                <Route path={routes.drivers} exact>
                    <DriversView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.warrantyAndReturn.viewList &&
                <Route path={routes.warrantyAndReturn.requests} exact>
                    <PartSupportRequestListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.warrantyAndReturn.viewDetails &&
                <Route path={routes.warrantyAndReturn.single} exact>
                    <WarrantyAndReturnSingle/>
                </Route>
            }
            {
                operatorAccessLevels.packages.warrantyAndReturn.editConfigurations &&
                <Route path={routes.warrantyAndReturn.settings.statuses} exact>
                    <WarrantyAndReturnStatusesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.warrantyAndReturn.editConfigurations &&
                <Route path={routes.warrantyAndReturn.settings.process} exact>
                    <WarrantyAndReturnProcessSettings/>
                </Route>
            }
            <Redirect to={routes.warrantyAndReturn.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default PartSupportRequestViews;
